import isBrowser from './isBrowser';

export default function isPreview() {
  const { hostname } = isBrowser() ? new URL(window.location) : {};
  return hostname.endsWith('sleuth.netlify.app');
}
